import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { getCustomizeCampaignState } from 'services/api/campaign';
import { CUSTOMIZE_CAMPAIGN_STATUS } from 'utils/campaign';

const useCustomizeCampaignData = (redirectOnCampaignClosed = false) => {
  const [customizeCampaign, setCustomizeCampaign] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const getCampaignState = async () => {
      try {
        const response = await getCustomizeCampaignState();
        if (
          redirectOnCampaignClosed &&
          response?.userInfo?.customizePage !== CUSTOMIZE_CAMPAIGN_STATUS.open
        ) {
          // redirect to add-ons if campaign closed for user
          history.push('/add-ons');
        } else {
          setCustomizeCampaign(response);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    getCampaignState();
  }, []);

  return { customizeCampaign, loading };
};

export default useCustomizeCampaignData;
